import React from 'react'
import AppLogoLink from 'components/AppLogoLink'
import { Redirect, Route } from 'react-router-dom'
import RouteLoginIndex from 'routes/login/index'
import RouteLoginConfirmation from './login/confirmation'
import RouteLoginResetPassword from './login/reset-password'
import RouteForgotPassword from 'routes/login/forgot-password'
import RouteRedirecting from './login/redirecting'
import RouteSetToken from 'routes/login/set-token'
import withQueryParams from 'components/withQueryParams'
import styled from '@emotion/styled'

const Main = styled.main`
  display: flex;
  height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const Container = styled.div`
  width: 30%;

  @media only screen and (max-width: 820px) {
    width: 50%;
  }

  @media only screen and (max-width: 620px) {
    width: 75%;
  }

  @media only screen and (max-width: 450px) {
    width: 90%;
  }
`

const RouteLogin = ({ match: { path }, location: { search }, query }) => (
  <React.Fragment>
    <Main>
      <Container>
        <AppLogoLink clientId={query.get('client_id')} />
        <Route path={path} component={RouteLoginIndex} exact />
        <Route
          path={`${path}/set-password`}
          render={() => <Redirect to={`${path}/reset-password`} />}
        />
        <Route
          path={`${path}/forgot-password`}
          component={RouteForgotPassword}
        />
        <Route
          path={`${path}/confirmation`}
          component={RouteLoginConfirmation}
        />
        <Route
          path={`${path}/reset-password`}
          component={RouteLoginResetPassword}
        />
        <Route
          path={`${path}/set-password`}
          render={() => (
            <Redirect to={{ pathname: `${path}/reset-password`, search }} />
          )}
        />
        <Route path={`${path}/set-token`} component={RouteSetToken} />
        <Route path={`${path}/redirecting`} component={RouteRedirecting} />
      </Container>
    </Main>
  </React.Fragment>
)

export default withQueryParams(RouteLogin)



// WEBPACK FOOTER //
// ./src/routes/login.js